import React from "react";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { useAuth } from "../../auth/auth";
import { toast } from "react-toastify";
import { changePassword } from "../../api/apiCall";
import { useForm } from "react-hook-form";

type FormValuesEditProfile = {
    oldPassword: string;
    newPassword: string;
}

const ChangePassword = () => {
    const {state} = useAuth();

    const {register, handleSubmit, formState: {errors}} = useForm<FormValuesEditProfile>();

    const onSubmit = async (data: any) => {
        const response = await changePassword(state.user?.token, data.oldPassword, data.newPassword);
        if(response === 200) {
            toast.success("Changed password successfully")
        }
    }

    return (
        <Box
            sx={{
                backgroundColor: "#fff",
                padding: "50px",
                margin: "auto",
                background: "#fff",
                border: '1px solid rgb(236, 236, 236)',
            }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                    <Typography sx={{color: "primary.dark"}}>Current Password</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <TextField
                        size="small"
                        type="password"
                        sx={{width: '400px'}}
                        {...register("oldPassword", {
                            required: "Old Password is required",
                        })}
                        error={!!errors.oldPassword}
                        placeholder="Current Password"
                    />
                </Grid>

                <Grid item xs={12} sm={2}>
                    <Typography sx={{color: "primary.dark"}}>New Password</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <TextField
                        size="small"
                        type="password"
                        sx={{width: '400px'}}
                        {...register("newPassword", {
                            required: "Old password is required",
                            min: 6
                        })}
                        error={!!errors.newPassword}
                        placeholder="Must contain a minimum of 6 characters"
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Typography sx={{color: "primary.dark"}}></Typography>
                </Grid>
                <Grid item xs={12} sm={10} mt={4}>
                    <Button
                        variant="contained"
                        style={{boxShadow: "none"}}
                        onClick={handleSubmit(onSubmit)}
                    >
                        Save Changes
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}

export default ChangePassword;
